import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { PatientProfile } from "@/core/types";
import { SHORT_LIVED_CACHE } from "@/lib/constants/cache";

import { getPatientProfile } from "../queryFunctions/getPatientProfile";
import { patientProfileKeys } from "../keyFactory";

type UsePatientProfileProps<TData = PatientProfile> = {
  select?: (data: PatientProfile) => TData;
};

type PatientProfileQueryOptions = UseQueryOptions<
  PatientProfile,
  unknown,
  PatientProfile,
  ReturnType<typeof patientProfileKeys.details>
>;

export function optionFactory() {
  return {
    queryFn: getPatientProfile,
    queryKey: patientProfileKeys.details(),
    staleTime: SHORT_LIVED_CACHE,
  } satisfies PatientProfileQueryOptions;
}

export function usePatientProfile<TData = PatientProfile>({
  select,
}: UsePatientProfileProps<TData> = {}) {
  return useQuery({ ...optionFactory(), select });
}
